export const fmtUSD = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency", currency: "USD", maximumFractionDigits: 0,
  }).format(Number(v));
};

export const fmtUSD2 = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(Number(v));
};

export const fmtNum = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  return new Intl.NumberFormat("en-US").format(Number(v));
};

export const parseNum = (v) => {
  const n = Number(String(v).replace(/[^0-9.]/g, ""));
  return isNaN(n) ? 0 : n;
};

export const apiErr = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};

// Simple-average blend of the automated baseline (AI Panel consensus when available,
// else RentCast AVM) with any owner-entered figures.
export const blendEstimates = (valuation, owner, panel) => {
  const usePanel = panel?.ok && panel.consensus_value;
  const base = usePanel ? panel.consensus_value : valuation.estimate;
  const sources = [{ label: usePanel ? "AI Panel consensus (RentCast comps)" : "Equitas estimate (RentCast AVM)", value: base, owner: false }];
  const z = parseNum(owner?.zestimate);
  const r = parseNum(owner?.redfin);
  const h = parseNum(owner?.homescom);
  if (z > 0) sources.push({ label: owner?.zestimateLive ? "Zillow Zestimate (live)" : "Zillow (owner-entered)", value: z, owner: !owner?.zestimateLive });
  if (r > 0) sources.push({ label: "Redfin (owner-entered)", value: r, owner: true });
  if (h > 0) sources.push({ label: "Homes.com (owner-entered)", value: h, owner: true });
  const vals = sources.map((s) => s.value).filter((v) => v > 0);
  const point = vals.length ? Math.round(vals.reduce((a, b) => a + b, 0) / vals.length) : base;
  const blended = sources.length > 1;
  const low = blended ? Math.min(...vals) : (usePanel ? panel.min : valuation.low);
  const high = blended ? Math.max(...vals) : (usePanel ? panel.max : valuation.high);
  return { sources, point, low, high, blended, baseline_label: sources[0].label };
};